import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

const UserProfile: React.FC = () => {
  const { user, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  if (!user) return null;
  
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  
  const handleLogout = () => {
    logout();
    setIsDropdownOpen(false);
  };
  
  // Get initials for avatar
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };
  
  return (
    <div className="user-profile">
      <button 
        className="profile-button" 
        onClick={toggleDropdown}
        aria-label="User profile"
      >
        <div className="user-avatar">
          {getInitials(user.name)}
        </div>
      </button>
      
      {isDropdownOpen && (
        <div className="profile-dropdown">
          <div className="profile-header">
            <div className="profile-info">
              <div className="profile-name">{user.name}</div>
              <div className="profile-email">{user.email}</div>
              {user.company && (
                <div className="profile-company">{user.company}</div>
              )}
            </div>
          </div>
          
          <div className="profile-menu">
            <Link to="/dashboard" className="profile-menu-item" onClick={() => setIsDropdownOpen(false)}>
              <span className="menu-icon">📊</span>
              <span>Dashboard</span>
            </Link>
            <Link to="/settings" className="profile-menu-item" onClick={() => setIsDropdownOpen(false)}>
              <span className="menu-icon">⚙️</span>
              <span>Settings</span>
            </Link>
            <button className="profile-menu-item logout" onClick={handleLogout}>
              <span className="menu-icon">🚪</span>
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
